import {Component, OnInit} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {environment} from '../../../../../free/src/environments/environment';
import {AuthService} from '../../../../../firebase/src/lib/services/auth.service';

@Component({
    selector: 'app-promo',
    templateUrl: './promo.component.html',
    styleUrls: ['./promo.component.scss']
})
export class PromoComponent implements OnInit {
    loading = false;
    apiUrl = environment.apiUrl;

    promo = null;
    successText = null;
    errorText = null;

    constructor(
        private http: HttpClient,
        private auth: AuthService
    ) {
    }

    ngOnInit(): void {
    }

    applyPromo() {
        this.loading = true;
        if (!this.promo) {
            return;
        }
        this.successText = null;
        this.errorText = null;

        this.http.post(`${this.apiUrl}/promo`, {promoId: this.promo}, {
            headers: {
                Authorization: `Bearer ${this.auth.userData?.stsTokenManager?.accessToken}`,
            },
            responseType: 'text'
        })
            .subscribe((res: any) => {
                this.promo = null;
                this.successText = 'Promo code applied successfully';
                this.loading = false;

            }, (error) => {
                this.errorText = 'Promo code not applied';

                this.loading = false;
            });
    }
}
